 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowStoppageData(props);
    };

    return (
            <a onClick={handleRouteClick}  title="Enroute Stoppages"><i className="icofont icofont-pause f20"></i> </a>
        
    );
};

export default ConsignmentActions;
